/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./participantSetting.vue?vue&type=template&id=8d48b616&scoped=true&"
import script from "./participantSetting.vue?vue&type=script&lang=js&"
export * from "./participantSetting.vue?vue&type=script&lang=js&"
import style0 from "./participantSetting.vue?vue&type=style&index=0&id=8d48b616&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48b616",
  null
  
)

export default component.exports